module.exports = __webpack_public_path__ + "img/contractor_all_risk.628a61b8.svg";